const mobileNavigation = {
  el: {
    root: document.querySelector<HTMLElement>('.mobile-navigation'),
    body: document.querySelector<HTMLElement>('.body'),
    header: document.querySelector<HTMLElement>('.header'),
    hamburger: document.querySelector<HTMLElement>('.header .hamburger'),
    triggers: document.querySelectorAll<HTMLElement>('.mobile-nav__button'),
    back: document.querySelectorAll<HTMLElement>('.mobile-navigation__back'),
    footer: document.querySelector<HTMLElement>('.mobile-navigation__footer'),
  },

  init() {
    if (this.el.root) {
      this.el.triggers.forEach((item) => {
        item.addEventListener('click', (e: Event & { target: HTMLButtonElement }) => {
          const navToSlideIn = document.querySelector<HTMLElement>(
            `.mobile-nav__level[data-nav="${e.target.dataset.nav}"]`
          )
          const navToSlideOut = document.querySelector<HTMLElement>('.mobile-nav__level[data-level="1"]')

          navToSlideIn.style.transform = `translateX(-${100 * parseInt(e.target.dataset.nav)}%)`
          navToSlideIn.style.opacity = '1'
          navToSlideOut.style.transform = 'translateX(-100%)'
          navToSlideOut.style.opacity = '0'
          this.el.footer.style.transform = 'translateX(-100%)'
          this.el.footer.style.opacity = '0'

          this.addPaddingToNavList()
        })
      })

      this.el.back.forEach((item) => {
        item.addEventListener('click', (e: Event & { target: HTMLButtonElement }) => {
          const navToSlideOut = document.querySelector<HTMLElement>(
            `.mobile-nav__level[data-nav="${e.target.dataset.nav}"]`
          )
          const navToSlideIn = document.querySelector<HTMLElement>('.mobile-nav__level[data-level="1"]')

          navToSlideIn.style.transform = 'translateX(0)'
          navToSlideOut.style.transform = 'translateX(0)'
          this.el.footer.style.transform = 'translateX(0)'

          navToSlideIn.style.opacity = '1'
          navToSlideOut.style.opacity = '0'
          this.el.footer.style.opacity = '1'
        })
      })
    }
  },
  reset() {
    document.querySelectorAll<HTMLElement>('.mobile-nav__level').forEach((item) => {
      setTimeout(() => {
        item.style.transform = 'translateX(0)'
        item.style.opacity = '1'
      }, 0)
    })
    this.el.footer.style.transform = 'translateX(0)'
    this.el.footer.style.opacity = '1'
    this.el.body.classList.remove('body--mobile-nav-open')
  },

  addPaddingToNavList() {
    //  Adjusting padding of nav list to fit quick access
    const quickAccess = document.querySelector<HTMLElement>('.mobile-navigation__quick-access')
    const navList = document.querySelector<HTMLElement>('.mobile-nav__list')

    if (quickAccess && navList) {
      const quickAccessHeight = quickAccess.offsetHeight
      navList.style.paddingBottom = `${quickAccessHeight + 30}px`
    }
  },
}

export default mobileNavigation
